import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import React, { FunctionComponent } from "react";

import Registration from "../../models/registration/Registration";

interface NumberOfRegistrationsChartData {
  name: string;
  Anmeldungen: number;
  pv: number;
}

interface Props {
  registrations: Registration[];
}

export const NumberOfRegistrationsChart: FunctionComponent<Props> = ({ registrations }: Props) => {
  const chartData = mapToChartData(registrations);

  return (
    <ResponsiveContainer width={"100%"} height={400}>
      <AreaChart
        data={chartData}
        margin={{
          top: 10,
          right: 10,
          left: 0,
          bottom: 0
        }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
        <XAxis dataKey="name" stroke="#64748b" />
        <YAxis stroke="#64748b" />
        <Tooltip
          contentStyle={{
            backgroundColor: "white",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)"
          }}
        />
        <Area type="monotone" dataKey="Anmeldungen" stroke="#3f38ff" fill="rgba(63, 56, 255, 0.1)" strokeWidth={3} />
      </AreaChart>
    </ResponsiveContainer>
  );
};

function mapToChartData(registrations: Registration[]): NumberOfRegistrationsChartData[] {
  const sortedRegistrations = registrations.sort(
    (a, b) => a.creation.createdAt.getTime() - b.creation.createdAt.getTime()
  );

  if (sortedRegistrations.length === 0) {
    return [];
  }

  const dates = getDatesInRange(sortedRegistrations[0].creation.createdAt, new Date());

  let currentNumberOfRegistrations = 0;
  return dates.map((date, index) => {
    const registrationsPerDate = registrations.filter(
      (value) => value.creation.createdAt.setHours(0, 0, 0, 0) === date.setHours(0, 0, 0, 0)
    );
    currentNumberOfRegistrations += registrationsPerDate.length;
    return {
      name: date.toLocaleDateString(),
      Anmeldungen: currentNumberOfRegistrations,
      pv: index
    };
  });
}

function getDatesInRange(start: Date, end: Date): Date[] {
  const dates: Date[] = [];
  for (let dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
    dates.push(new Date(dt));
  }
  return dates;
}
